import React from 'react';
import Layout from '../components/Layout';

const Ily = () => {
    return (
        <Layout>
            <div className="flex justify-center items-center flex-col">
                <img
                    src="https://www.line-stickers.com/wp-content/uploads/2020/01/Mochi-Mochi-Peach-Cat-Friend-2-.png"
                    alt="cute cat"
                />
                <h1 className="font-work text-4xl font-bold py-4">
                    Hai I love you
                </h1>
            </div>
        </Layout>
    );
};

export default Ily;
